export const mockData = {
  menuCategories: [
    {
      name: "🍔✨ Nos Gourmets",
      description: "Servi avec frites + 1 boisson 33cl",
      items: [
        {
          name: "Le Bacon",
          price: "13,00 €",
          description: "mesclun, tomates, oignons rouges, bœuf haché 150g, bacon, œuf, cheddar, sauce maison"
        },
        {
          name: "Chèvre Burger",
          price: "13,00 €",
          description: "mesclun, tomates, oignons rouges, bœuf haché 150g, chèvre, miel, sauce maison"
        },
        {
          name: "Tenders Burger",
          price: "13,00 €",
          description: "salade, oignons rouges, escalope panée, œuf, cheddar, sauce maison"
        },
        {
          name: "Burger Savoureux",
          price: "14,00 €",
          description: "mesclun, tomates, oignons rouges, bœuf haché 150g, avocat, gorgonzola, sauce maison"
        },
        {
          name: "Charlie Burger",
          price: "15,00 €",
          description: "mesclun, tomates, oignons rouges, bœuf haché 150g, escalope de poulet, œuf, cheddar, sauce américaine"
        }
      ]
    },
    {
      name: "🍔 Nos Burgers",
      description: "Servi avec frites + 1 boisson 33cl",
      items: [
        { 
          name: "Burger Cheese", 
          price: "7,50 €", 
          description: "Steak 45g, cheddar, sauce maison, salade, tomates, oignons rouges." 
        },
        { 
          name: "Burger Fish", 
          price: "7,50 €", 
          description: "Poisson pané, cheddar, sauce fish, salade, tomates." 
        },
        { 
          name: "Burger Double Cheese", 
          price: "8,50 €", 
          description: "2 steaks 45g, cheddar, sauce maison, salade, tomates, oignons rouges." 
        },
        { 
          name: "Burger Chicken", 
          price: "8,50 €", 
          description: "Poulet pané, cheddar, sauce maison, salade, tomates, oignons rouges." 
        },
        { 
          name: "Burger Triple Cheese", 
          price: "9,50 €", 
          description: "3 steaks 45g, cheddar, sauce maison, salade, tomates, oignons rouges." 
        },
        { 
          name: "Burger Egg", 
          price: "9,50 €", 
          description: "2 steaks 45g, œuf, cheddar, sauce Biggy, salade, tomates." 
        },
        { 
          name: "Burger Mix Charlie", 
          price: "9,50 €", 
          description: "Steak 45g, poulet pané, cheddar, sauce maison, salade, tomates, oignons rouges." 
        }
      ]
    },
    {
      name: "🥖 Nos Sandwichs",
      description: "Baguette ou tortilla • Servi avec frites + 1 boisson 33cl • Sauces au choix : Mayo, Ketchup, Harissa, Samouraï, Algérienne, Biggy, Blanche, Poivre, Chilli, Barbecue",
      items: [
        { 
          name: "Sandwich Omelette", 
          price: "9,00 €", 
          description: "Demi-baguette, omelette, crudités, cheddar." 
        },
        { 
          name: "Sandwich Poulet", 
          price: "10,00 €", 
          description: "Demi-baguette, émincé de poulet, crudités, cheddar, œuf." 
        },
        { 
          name: "Sandwich Kebab", 
          price: "10,00 €", 
          description: "Demi-baguette, kebab, crudités." 
        },
        { 
          name: "Sandwich Américain", 
          price: "10,00 €", 
          description: "Demi-baguette, 2 steaks 45g, crudités, cheddar, œuf." 
        },
        { 
          name: "Sandwich Boursin", 
          price: "11,00 €", 
          description: "Demi-baguette, crudités, poulet boursin, cheddar." 
        },
        { 
          name: "Sandwich Tenders", 
          price: "11,00 €", 
          description: "Demi-baguette, tenders, crudités, cheddar." 
        },
        { 
          name: "Sandwich Mixte", 
          price: "13,00 €", 
          description: "Demi-baguette, 2 steaks 45g + escalope de poulet, crudités, cheddar, œuf." 
        }
      ]
    },
    {
      name: "🥗 Salades",
      items: [
        {
          name: "César",
          price: "9,50 €",
          description: "salade, tomates, poulet pané"
        },
        {
          name: "Chèvre miel",
          price: "9,50 €",
          description: "salade, tomates, chèvre chaud, miel"
        }
      ]
    },
    {
      name: "🌯 Tacos",
      description: "Servi avec frites + 1 boisson 33cl • Sauces au choix : Mayo, Ketchup, Harissa, Samouraï, Algérienne, Biggy, Blanche, Poivre, Chilli, Barbecue",
      items: [
        {
          name: "Tacos",
          price: "10,00 €",
          description: "Viandes: kebab, escalope, tenders, nuggets, steak, poulet pané, cordon bleu, crousty"
        },
        {
          name: "Supplément viande",
          price: "+1,00 €"
        },
        {
          name: "Supplément cheddar ou raclette",
          price: "+1,00 €"
        }
      ]
    },
    {
      name: "🍽️ Assiettes",
      description: "Servi avec frites + 1 boisson 33cl",
      items: [
        {
          name: "Assiette Escalope",
          price: "13,00 €",
          description: "crudités, escalope, œuf, cheddar, olives + pain"
        },
        {
          name: "Assiette Tenders",
          price: "13,00 €",
          description: "crudités, tenders, œuf, cheddar fondu + pain"
        },
        {
          name: "Assiette Kebab",
          price: "13,00 €",
          description: "crudités, kebab, œuf, cheddar fondu + pain"
        }
      ]
    },
    {
      name: "🥣 Bowls",
      description: "Servi avec boisson 33cl",
      items: [
        {
          name: "Bowl",
          price: "9,50 €",
          description: "1 viande au choix (Cordon Bleu, Kebab, Tenders, Escalope, Crousty) + sauce fromagère + 2 sauces au choix"
        },
        {
          name: "Supplément cheddar ou raclette",
          price: "+1,00 €"
        }
      ]
    },
    {
      name: "🍚 Tastys Crousty",
      description: "Sauce chili thaï et barbecue • Petit 6€ ou Grand 9€ • +1€ avec boisson 33cl",
      items: [
        {
          name: "Tasty Tenders – Petit",
          price: "6,00 €",
          description: "Riz blanc, sauce blanche maison, tenders, oignons crispy, persil (+1€ avec boisson)"
        },
        {
          name: "Tasty Tenders – Grand",
          price: "9,00 €",
          description: "Riz blanc, sauce blanche maison, tenders, oignons crispy, persil (+1€ avec boisson)"
        },
        {
          name: "Tasty Escalope – Petit",
          price: "6,00 €",
          description: "Riz blanc, sauce blanche maison, escalope fraîche, oignons crispy, persil (+1€ avec boisson)"
        },
        {
          name: "Tasty Escalope – Grand",
          price: "9,00 €",
          description: "Riz blanc, sauce blanche maison, escalope fraîche, oignons crispy, persil (+1€ avec boisson)"
        },
        {
          name: "Tasty Crousty – Petit",
          price: "6,00 €",
          description: "Riz blanc, sauce blanche maison, crousty, oignons crispy, persil (+1€ avec boisson)"
        },
        {
          name: "Tasty Crousty – Grand",
          price: "9,00 €",
          description: "Riz blanc, sauce blanche maison, crousty, oignons crispy, persil (+1€ avec boisson)"
        }
      ]
    },
    {
      name: "👶 Menu Enfant",
      items: [
        {
          name: "Menu Hamburger",
          price: "7,50 €",
          description: "1 cheese + frites + 1 Capri Sun + 1 compote"
        },
        {
          name: "Menu Nuggets",
          price: "7,50 €",
          description: "5 nuggets + frites + 1 Capri Sun + 1 compote"
        }
      ]
    },
    {
      name: "🌶️ Tex Mex",
      items: [
        { name: "Nuggets (6 pcs)", price: "5,90 €" },
        { name: "Wings (4 pcs)", price: "5,90 €" },
        { name: "Tenders (4 pcs)", price: "5,90 €" },
        { name: "Crousty (4 pcs)", price: "5,90 €" },
        {
          name: "Box",
          price: "29,90 €",
          description: "20 tenders ou 30 wings + portions de frites + 1 maxi boisson"
        }
      ]
    },
    {
      name: "🍟 Frites",
      items: [
        { name: "Nature petite", price: "3,00 €" },
        { name: "Nature moyenne", price: "4,00 €" },
        { name: "Nature grande", price: "5,00 €" },
        { name: "Petite Frites Cheddar", price: "4,50 €" },
        { name: "Cheddar moyenne", price: "5,50 €" },
        { name: "Cheddar grande", price: "6,50 €" },
        { name: "Supplément bacon", price: "+2,00 €" }
      ]
    },
    {
      name: "🍰 Desserts",
      items: [
        { name: "Tiramisu", price: "4,00 €" },
        { name: "Tarte au Daim", price: "3,50 €" }
      ]
    },
    {
      name: "🥤 Boissons",
      items: [
        { name: "Canette 33cl", price: "1,80 €" },
        { name: "Eau 50cl", price: "1,80 €" }
      ]
    }
  ],
  info: {
    address: "27 Rue Charles de Gaulle, 91400 Orsay",
    phone: "09 86 15 17 24",
    googleMapsLink: "https://www.google.com/maps/place/CHARLIE+FOODS",
    directionsLink: "https://www.google.com/maps/place/CHARLIE+FOODS.+Vente+sur+place%2F+livraison+%C3%A0+domicile+et+emporter/@48.6935335,2.1733276,14.91z/data=!4m6!3m5!1s0x47e679003f5d146f:0x2debb7669a89d1a!8m2!3d48.7016253!4d2.1896881!16s%2Fg%2F11whdhk6qm?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
  },
  gallery: [
    {
      src: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxidXJnZXJ8ZW58MHx8fHwxNzU4MzcwMDQ0fDA&ixlib=rb-4.1.0&q=85",
      alt: "Burger délicieux"
    },
    {
      src: "https://images.unsplash.com/photo-1509722747041-616f39b57569?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxiYWd1ZXR0ZSUyMHNhbmR3aWNofGVufDB8fHx8MTc1ODQ1Mzk0Mnww&ixlib=rb-4.1.0&q=85",
      alt: "Sandwich Baguette"
    },
    {
      src: "https://images.unsplash.com/photo-1504544750208-dc0358e63f7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx0YWNvc3xlbnwwfHx8fDE3NTgzNDk5NDF8MA&ixlib=rb-4.1.0&q=85",
      alt: "Tacos savoureux"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_de93eba8-68aa-47c4-8a98-1f57832425cc/artifacts/i9ft8glx_image.png",
      alt: "Ojja tunisienne"
    },
    {
      src: "https://images.unsplash.com/photo-1595872252167-3e1c785c1fc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx0ZXgtbWV4fGVufDB8fHx8MTc1ODQ1Mzk1Nnww&ixlib=rb-4.1.0&q=85",
      alt: "Tex-Mex"
    },
    {
      src: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHx0aXJhbWlzdXxlbnwwfHx8fDE3NTg0NTM5NjF8MA&ixlib=rb-4.1.0&q=85",
      alt: "Tiramisu"
    }
  ],
  about: [
    {
      icon: "❤️",
      title: "Cuisine avec Passion",
      description: "Chaque plat est préparé avec amour et attention aux détails pour votre plus grand plaisir."
    },
    {
      icon: "🥩",
      title: "Qualité Halal",
      description: "Tous nos produits respectent les standards halal les plus stricts pour votre tranquillité d'esprit."
    },
    {
      icon: "⚡",
      title: "Service Rapide",
      description: "Sur place ou à emporter, profitez de nos plats préparés avec soin."
    }
  ],
  paymentInfo: [
    "💳 Paiement par carte bancaire",
    "🍽️ Tickets restaurant acceptés",
    "🏠 Sur place",
    "🥡 À emporter",
    "🎓 -10% pour les étudiants de 11h à 15h"
  ],
  heroSlogan: "Fraîcheur, rapidité et goût — servis avec le sourire."
};